<template>
  <div class="notice-style">
    <div class="list">
      <van-list
        v-model="loading"
        :finished="finished"
        :finished-text="$t('text.t227')"
        :offset="10"
        @load="getlist"
      >
        <div class="item" v-for="item in list" :key="item.id">
          <div class="t1">{{language==1?item.title:item.Etitle}}</div>
          <div class="t2">{{$parseTime(item.updatetime)}}</div>
          <div class="t3" v-html="language==1?item.content:item.Econtent"></div>
        </div>
      </van-list>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  components: {},
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      page: 1,
      limit: 20,
    };
  },
  computed: {
    ...mapState(["language"]),
  },
  created() {},
  mounted() {},
  methods: {
    getlist() {
      let arg = {
        page: this.page,
        limit: this.limit,
      };
      this.$http.get("/index/AnnounceList", arg).then((res) => {
        const { current_page, data, last_page } = res.data;
        if (current_page >= last_page) this.finished = true;
        this.page++;
        this.loading = false;
        this.list = [...this.list, ...data];
      });
    },
  },
};
</script>

<style lang="less">
.notice-style {
  padding: 0 20px;
  .list {
    .item {
      padding: 15px 6px;
      border-bottom: 1px solid #e1e1e1;
      .t1 {
        font-size: 15px;
        font-family: PingFang SC;
        font-weight: bold;
        color: #323232;
        margin-bottom: 10px;
      }
      .t2 {
        font-size: 10px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #909090;
        margin-bottom: 10px;
      }
      .t3 {
        font-size: 12px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #909090;
      }
    }
  }
}
</style>